module.exports = __webpack_public_path__ + "media/images/order_list-476204a4.svg";